/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mobile_Camera_Permission_RequiredInputs */

const en_mobile_camera_permission_required = /** @type {(inputs: Mobile_Camera_Permission_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Camera access is needed to scan pages.`)
};

const es_mobile_camera_permission_required = /** @type {(inputs: Mobile_Camera_Permission_RequiredInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Se necesita acceso a la cámara para escanear páginas.`)
};

/**
* | output |
* | --- |
* | "Camera access is needed to scan pages." |
*
* @param {Mobile_Camera_Permission_RequiredInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const mobile_camera_permission_required = /** @type {((inputs?: Mobile_Camera_Permission_RequiredInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mobile_Camera_Permission_RequiredInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_mobile_camera_permission_required(inputs)
	return en_mobile_camera_permission_required(inputs)
});